<form [formGroup]="formGroup">
  <mat-form-field
    appearance="outline"
    class="no-subscript"
    [ngClass]="{
      hilite: hilite
    }"
  >
    <mat-label>{{ label ? label : "ASCC Links" }}</mat-label>
    <mat-chip-grid
      #chipListDoc
      aria-label="Document selection"
      class="matchiplistLinks"
      formControlName="documentCtrl"
    >
      <mat-chip-row
        *ngFor="let document of relatedDocuments; trackBy: trackByRelatedDoc"
        [selectable]="!(disabled ?? false)"
        [removable]="!disabled && !document?.disabled"
        (removed)="removeDoc(document)"
        [ngClass]="document?.cssClass"
      >
        <span
          class="btn-link"
          (click)="openDocument(document)"
          [ngClass]="{
            canceledRD:
              document?.relatedDocumentStatus == formStatusEnum.Canceled,
            closedRD: document?.relatedDocumentStatus == formStatusEnum.Closed
          }"
          >{{ document?.relatedDocumentSerialNo }}</span
        >
        <mat-icon
          matChipRemove
          *ngIf="!disabled && !document?.disabled"
          class="d-print-none"
          >cancel</mat-icon
        >
      </mat-chip-row>

      <input
        *ngIf="!control"
        matInput
        aria-label="relatedforms"
        #documentInput
        [matAutocomplete]="autoDoc"
        [matChipInputFor]="chipListDoc"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="true"
        (matChipInputTokenEnd)="addDoc($event)"
        (keyup)="onDocChange($event)"
        [disabled]="
          disabled ||
          (maxItems > 0 && (relatedDocuments?.length ?? 0) >= maxItems)
        "
        class="without-form-control"
      />
      <input
        *ngIf="control"
        [formControl]="control"
        matInput
        aria-label="relatedforms"
        #documentInput
        [matAutocomplete]="autoDoc"
        [matChipInputFor]="chipListDoc"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="true"
        (matChipInputTokenEnd)="addDoc($event)"
        (keyup)="onDocChange($event)"
        class="with-form-control"
      />
    </mat-chip-grid>
    <mat-autocomplete
      #autoDoc="matAutocomplete"
      (optionSelected)="selectedDoc($event)"
    >
      <mat-optgroup
        *ngFor="let type of documentTypes; trackBy: trackByDocTypeId"
        [label]="type.description ?? type.name ?? ''"
      >
        <mat-option
          *ngFor="let document of type.documents; trackBy: trackByDocumentId"
          [value]="document"
          [disabled]="
            maxItems > 0 && (relatedDocuments?.length ?? 0) >= maxItems
          "
          class="option"
          [ngClass]="{
            'display-none':
              (document.formID === formID && document.type === formType) ||
              document.status == formStatusEnum.Draft
          }"
        >
          <span
            [ngClass]="document.cssClass"
            class="bold"
            [innerHTML]="document.serialNo ?? '' | highlightSearch : filter"
          ></span>
          <span
            class="small description ml-2"
            *ngIf="!disabled && document?.description"
            [matTooltip]="document?.description ?? ''"
            matTooltipPosition="right"
            matTooltipClass="tooltip-white tooltip-wide"
            [matTooltipDisabled]="disableTooltips"
            [innerHTML]="document?.description ?? '' | highlightSearch : filter"
          >
          </span>
        </mat-option>
      </mat-optgroup>
    </mat-autocomplete>
    <mat-icon matSuffix class="search-icon" *ngIf="!disabled">search</mat-icon>
  </mat-form-field>
</form>
